import { images } from 'src/images';
import { IRouteAlteration } from '../models';
import { LiteralService } from '../services/literal/literal.service';
import { formData } from './alterationData';
import { InputType } from '../models/enums';
import moment from 'moment';
import { TooltipPosition } from '../shared/tooltip/tooltip-position';

export async function getAlterationForm(alterationDetail: IRouteAlteration, newAlteration: boolean, isEditing: boolean, literalService: LiteralService): Promise<formData[]> {
  const allowEdit = newAlteration || isEditing;
  const data: formData[] = [
    {
      img: images.alterations.alteration,
      title: 'alterations.data.name',
      value: alterationDetail.name ?? '',
      color: true,
      edit: allowEdit ? {
        required: true,
        inputType: InputType.TEXT,
        valueToChange: 'name',
        placeholder: literalService.get('alterations.data.namePlaceholder', true),
      } : false,
    },
    {
      img: images.alterations.calendar,
      title: 'alterations.data.startDate',
      value: alterationDetail.startDateTime ? moment(alterationDetail.startDateTime).format('YYYY-MM-DD') : undefined,
      color: true,
      calendar: {
        showOnTop: false,
        hideCalendar: false,
        showYear: false,
        onlyFutureDays: true,
        possibleMultipleDates: false
      },
      edit: allowEdit ? {
        required: true,
        inputType: InputType.DATE,
        valueToChange: 'startDate',
        id: 'alteration-startDate',
        placeholder: 'alterations.data.startDatePlaceholder',
      } : false,
    },
    {
      img: images.clock,
      title: 'alterations.data.startTime',
      value: alterationDetail.startDateTime ? moment(alterationDetail.startDateTime).format('HH:mm') : undefined,
      color: true,
      edit: allowEdit ? {
        required: true,
        inputType: InputType.TIME,
        valueToChange: 'startTime',
        placeholder: 'alterations.data.startTime',
      } : false,
    },
    {
      img: images.alterations.calendar,
      title: 'alterations.data.endDate',
      value: alterationDetail.endDateTime ? moment(alterationDetail.endDateTime).format('YYYY-MM-DD') : undefined,
      color: true,
      calendar: {
        showOnTop: false,
        hideCalendar: false,
        showYear: false,
        onlyFutureDays: true,
        possibleMultipleDates: false,
        minDate: alterationDetail.startDateTime && moment(alterationDetail.startDateTime).isValid()
          ? moment(alterationDetail.startDateTime).format('DD/MM/YYYY')
          : undefined,
      },
      edit: allowEdit ? {
        required: true,
        inputType: InputType.DATE,
        valueToChange: 'endDate',
        id: 'alteration-endDate',
        placeholder: 'alterations.data.endDatePlaceholder',
      } : false,
    },
    {
      img: images.clock,
      title: 'alterations.data.endTime',
      value: alterationDetail.endDateTime ? moment(alterationDetail.endDateTime).format('HH:mm') : undefined,
      color: true,
      edit: allowEdit ? {
        required: true,
        inputType: InputType.TIME,
        valueToChange: 'endTime',
        placeholder: 'alterations.data.endTime',
      } : false,
    },
    {
      img: images.info,
      title: 'alterations.data.informativeMessage',
      value: alterationDetail.informativeMessage,
      color: true,
      tooltipPosition: TooltipPosition.LEFT,
      edit: allowEdit ? {
        required: true,
        inputType: InputType.LONG_TEXT,
        valueToChange: 'informativeMessage',
        placeholder: literalService.get('maxChar250', true),
        maxLength: 250,
        rows: 4,
      } : false,
    },
  ];
  return data;
}
